<template> 
    <div class="app-inner" id="AppAuthDetaii">
          <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
            </div>
            <div class="edit-from">
         <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
          <div class="p-tit-c">
            <div class="businessDetail-info flex align-cen">
                 <div class="list">
                    工况名称：{{infoList.name}}
                </div>
                 <div class="list">
                工况ID：{{infoList.id}}
                </div>
                 <div class="list">
                    创建时间：{{infoList.createTime}}
                </div>
            </div>
             <div class="businessDetail-info flex align-cen">
                                 <div class="list" style="width:100%;color:red">
                工况文件下载地址：{{infoList.file}}
                </div>
             </div>
          </div>
            <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  日志信息
            </div>
        </div>
          <div class="businessDetail-data-table">
               <el-table
            :data="list"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
             <el-table-column
            prop="operateTime"
            label="时间"
           align="center"
             >
            </el-table-column>
            <el-table-column
            prop="action"
            label="操作行为"
           align="center"
             >
            </el-table-column>
             <el-table-column
            prop="operator"
            label="操作人员"
           align="center"
             >
            </el-table-column>
                   <el-table-column
            label="备注"
           align="center"
             >
                    <template slot-scope="scope">
                        <p >{{scope.row.remark || '-'}}</p>
                      </template>
            </el-table-column>
               </el-table>
                <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
               </div>
            </div>
    </div>
</template>
<script>
import { omDetail,getAppConditionsLog} from "@/api/index/index"  //获取工况详情、日志信息
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
export default {
    name:'omDetail',
     components:{
      paginaTion,
    },
    data() {
        return {
            infoList:{

            },
            list:[],
             currentPage:1,
           pageSize:10,
           totalCount:0
        }
    },
    created() {
        this.getDetail();
        this.getList()
    },
    methods: {
        // 获取日志列表
          getList(){
            let params = {
                id:this.$route.query.id,
                current:this.currentPage,
                size:this.pageSize
            }
            getAppConditionsLog(params)
            .then(res =>{
              if(res.data.records){
                this.list = res.data.records
                this.totalCount = res.data.total
              }
              console.log(res)
            })
        },
        // 获取详情
        getDetail(){
               omDetail({
                id:this.$route.query.id
              },'get')
            .then(res => {
                this.infoList = res.data
            })
            .catch(err => {
            })
        },
        // 返回
        reback(){
            this.$router.push('/AppConditions')
        },
                            // 子组件触发
      emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getList()
      },
    },
}
</script>
<style lang="scss" scoped>
.edit-from{
    margin-bottom: 44px;
    .p-tit-c{
        margin: 20px 0;
    }
      .businessDetail-info{
        padding: 30px 20px 20px 20px; 
      .list{
                width: 33%;
              
            }
    }
    .businessDetail-data-table{
        margin-top: 20px;
    }
}
</style>